import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ClusterListComponent } from '@fi-app/cluster/cluster-list/cluster-list.component';

export const FiClusterListState: Ng2StateDeclaration = {
    name: FiStateNames.Cluster.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: ClusterListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiClusterListStateResolve_pageTitle],
    },
    data: {
        addSref: FiStateNames.Cluster.Add,
    },
};

export function FiClusterListStateResolve_pageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByItem(ObjectTypes.Cluster);
}
